import { IntegrityMonitorAssignRulesFormWebComponent } from './component/IntegrityMonitorAssignRulesFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_ASSIGN_RULES_FORM } from '../../../webcomponents.constants';

export { IntegrityMonitorAssignRulesFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_ASSIGN_RULES_FORM,
  IntegrityMonitorAssignRulesFormWebComponent
);
